import React from 'react';

import { FolderOpen } from 'lucide-react';

import { EmptyWrapper, EmptyTitle, EmptyDescription } from './Table.styles';

const EmptyState = () => {
  return (
    <EmptyWrapper>
      <FolderOpen size={48} strokeWidth={1.4} />

      <EmptyTitle>Folder is empty</EmptyTitle>

      <EmptyDescription>Upload files or folders to get started.</EmptyDescription>
    </EmptyWrapper>
  );
};

export default EmptyState;
